/** "120 t", "1,234.5 val."; grouped like the money next to it (see components/format/currency). */
export const formatQuantity = (quantity: number | null, unit?: string | null): string => {
  const amount = (quantity || 0).toLocaleString("en-US", { maximumFractionDigits: 3 });
  return unit ? `${amount} ${unit}` : amount;
};
